import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './superuser-selector-modal.css'

const SuperuserSelectorModalPartners = ({ handleSearchInputChange, results }) => (
  <div styleName="content">
    <div styleName="search">
      Search by Partner ID, name or Portal User email:
      <input styleName="input" type="text" onChange={handleSearchInputChange} />
    </div>
    {results && (
      <div styleName="results">
        Click to view partner:
        <ul>
          {results && results.map((item, index) => (
            <li key={index}>
              <a href={`/p/${item.id}`} styleName="link">
                {item.name} ({item.id})
              </a>
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
)

SuperuserSelectorModalPartners.propTypes = {
  handleSearchInputChange: PropTypes.func,
  results: PropTypes.array,
}

export default CSSModules(SuperuserSelectorModalPartners, styles)



/** WEBPACK FOOTER **
 ** ./src/components/superuser-selector-modal/superuser-selector-modal-partners.js
 **/